// Layout for the private pages — ports app/(privado)/layout.tsx.
//
// Same structure as before: shared nav, page transition.
// `<Outlet/>` takes the place of `children`, and the route guard that used to
// live in proxy.ts now wraps this in the router.
//
// Two navigations, one per shape of screen: the top bar on the desktop, the
// carousel at the bottom on the phone. Only one is ever visible — each hides
// itself at the breakpoint the other takes over.

import { Suspense } from "react";
import { Outlet } from "react-router";
import { Navegacao } from "@/components/ui/Navegacao";
import { BarraInferior } from "@/components/ui/BarraInferior";
import { TransicaoPagina } from "@/components/ui/TransicaoPagina";
import { ACarregar } from "@/components/ui/EstadoConsulta";
import { EcraDeJogoProvider, useEcraDeJogo } from "@/components/ui/EcraDeJogo";

export function PrivateLayout() {
  return (
    <EcraDeJogoProvider>
      <Moldura />
    </EcraDeJogoProvider>
  );
}

/**
 * A moldura à volta da página: as duas navegações, e o espaço que a de baixo
 * ocupa.
 *
 * Separada do provider porque tem de LER o contexto que ele cria — um
 * componente não vê o provider que ele próprio rende.
 *
 * Com um tabuleiro a ser jogado, as duas desaparecem e o espaço reservado à de
 * baixo vai com elas: o tabuleiro fica com o ecrã todo, que é a única coisa que
 * ali interessa (ver EcraDeJogo.tsx).
 */
function Moldura() {
  const { aJogar } = useEcraDeJogo();

  return (
    <>
      {!aJogar && <Navegacao />}
      {/* A barra de baixo é fixa e tapa o fim da página; este espaço devolve-o.
          Só no telemóvel — no desktop a barra não existe. */}
      <div className={aJogar ? "" : "pb-[calc(7rem+env(safe-area-inset-bottom))] sm:pb-0"}>
        <TransicaoPagina>
          {/* Cobre as páginas carregadas à parte (mapa, calendário, os dois
              tabuleiros — ver routes.tsx). O mesmo esqueleto que uma consulta
              mostra, para a espera parecer a mesma coisa. */}
          <Suspense fallback={<ACarregar linhas={2} />}>
            <Outlet />
          </Suspense>
        </TransicaoPagina>
      </div>
      {!aJogar && <BarraInferior />}
    </>
  );
}
